import React from 'react';

const base =
  'w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-ink placeholder:text-ink-faint focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/15 disabled:cursor-not-allowed disabled:bg-slate-50';

export const Input = React.forwardRef(function Input(
  { error, className = '', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={`${base} ${error ? 'border-danger' : ''} ${className}`}
      {...rest}
    />
  );
});

export const Textarea = React.forwardRef(function Textarea(
  { error, className = '', rows = 3, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={`${base} resize-y ${error ? 'border-danger' : ''} ${className}`}
      {...rest}
    />
  );
});

export const Select = React.forwardRef(function Select(
  { error, className = '', children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={`${base} pr-8 ${error ? 'border-danger' : ''} ${className}`}
      {...rest}
    >
      {children}
    </select>
  );
});

export const DateInput = React.forwardRef(function DateInput(props, ref) {
  return <Input ref={ref} type="date" {...props} />;
});

export const NumberInput = React.forwardRef(function NumberInput(props, ref) {
  return <Input ref={ref} type="number" {...props} />;
});

export default Input;
